import * as z from "./external.js";
export * from "./external.js";
export { z };
export default z;